import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import LoadMask from '../../../lib/react-storefront/LoadMask';
import SearchContext from '../../../lib/react-storefront/search/SearchContext';
import SearchSuggestionGroup from './SearchSuggestionGroup';


const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    position: 'relative',
    overflowY: 'auto'
  },
  group: {
    margin: theme.spacing(0, 0, 2, 0)
  }
}));

function SearchSuggestions({ classes, render }) {
  const classesStyles = useStyles();

  const { state } = useContext(SearchContext);

  return (
    <>
      <LoadMask show={state.loading} transparent={true} />
      <div className={classesStyles.root}>
        {render ? render(state) : state.groups && state.groups.map(group => (
          <div key={group.caption} className={classesStyles.group}>
            <SearchSuggestionGroup {...group} />
          </div>
        ))}
      </div>
    </>
  );
}

SearchSuggestions.propTypes = {
  classes: PropTypes.object
};

export default SearchSuggestions;